export default __webpack_public_path__ + "static/media/Roboto-Bold.75371f53.ttf";